var trading = /** @class */ (function () {
    function trading() {
    }
    trading.STORE_MODULE_NAME = 'trading';
    return trading;
}());
export { trading };



//////////////////
// WEBPACK FOOTER
// ./src/plugins/trading/lib/trading.cls.ts
// module id = null
// module chunks = 